import { EmptyState, Icons, Spinner } from "construct-ui";
import SingleSelectComponent from "../../../components/single-select/single-select.component";
import ViewBase from "../../view-base.view";
import GlobalHierarchyModel from "../../../models/master-data-management/global-hierarchy/global-hierarchy.model";
import TreeComponent from "../../../components/treeview/tree.component";
import codeMasterModel from "../../../models/common/code-master.model";

/**
 * Global Hierarchy View
 * 
 * Global hierarchy view page, displays location and gscm division hierarchy
 * 
 * @author Darrus Goh
 */
export default function GlobalHierarchyView() {
    ViewBase.call(this);

    const LIST_HEIGHT = '700px';
    const CODEMASTER_CATEGORY = 'HierarchyType';

    const DEFAULT_FIELD_VALUES = {
        parentName: '',
        code: '',
        name: '',
        description: '',
        etcInfo: '',
        hierarchyLevel: '',
        status: ''
    };

    let hierarchyTypes = [];
    let selectedHierarchyType = null;

    let isTreeLoading = false;
    let isDetailsLoading = false;
    let hierarchyTree = [];
    let hierarchyDetail = structuredClone(DEFAULT_FIELD_VALUES);

    const getHierarchyTypes = () => {
        return codeMasterModel.getByCategoryV2({ category: CODEMASTER_CATEGORY })
            .then((result) => {
                hierarchyTypes = result;
            })
            .catch((error) => {
                this.handleError(error);
            });
    };

    const getHierarchyTree = (hierarchyType) => {
        isTreeLoading = true;
        GlobalHierarchyModel.getHierarchyTree(hierarchyType)
            .then((result) => {
                hierarchyTree = result;
            })
            .catch((error) => {
                this.handleError(error);
            })
            .finally(() => {
                isTreeLoading = false;
            });
    };

    const getHierarchyDetail = (hierarchyType, hierarchyCode) => {
        isDetailsLoading = true;
        GlobalHierarchyModel.getHierarchyDetail(hierarchyType, hierarchyCode)
            .then((result) => {
                hierarchyDetail = result;
            })
            .catch((error) => {
                this.handleError(error);
            })
            .finally(() => {
                isDetailsLoading = false;
            });
    };

    const resetFields = () => {
        hierarchyDetail = structuredClone(DEFAULT_FIELD_VALUES);
    };

    return {
        oninit: () => {
            getHierarchyTypes();
        },
        view: () => [
            m('.row.g-1', { style: { height: LIST_HEIGHT } },
                // LEFT PANE
                m('.col-4.h-100',
                    m('.card.h-100',
                        m('.card-body.h-100',
                            m('.d-flex.h-100.flex-column.gap-3',
                                m('div',
                                    m('label.form-label', this.getText('LT00000013', 'Data Type')),
                                    m(SingleSelectComponent, {
                                        items: hierarchyTypes,
                                        selectedItem: selectedHierarchyType,
                                        checkmark: true,
                                        filterable: false,
                                        allowEmpty: false,
                                        onSelect: (value) => {
                                            selectedHierarchyType = value;
                                            getHierarchyTree(selectedHierarchyType.code);
                                            resetFields();
                                        }
                                    })
                                ),
                                m('.flex-fill.overflow-auto.position-relative',
                                    hierarchyTree && hierarchyTree.length > 0
                                        ? m(TreeComponent, {
                                            items: hierarchyTree,
                                            multiple: true,
                                            globalOnClick: (value) => {
                                                getHierarchyDetail(selectedHierarchyType.code, value);
                                            }
                                        })
                                        : m(EmptyState, {
                                            class: 'placeholder-text-color',
                                            icon: Icons.ARCHIVE,
                                            content: this.getText("LT00000317", "No results found"),
                                            fill: true
                                        })
                                ),
                                isTreeLoading && m(Spinner, { fill: true, background: true, active: true })
                            )
                        )
                    )
                ),
                // RIGHT PANE
                m('.col-8',
                    m('.card',
                        m('.card-body',
                            m('.row.g-3',
                                m('.col-4',
                                    m('label.form-label', this.getText('LT00000777', 'Parent Name')),
                                    m('input.form-control', { type: 'text', value: hierarchyDetail?.parentName, disabled: 'true', readonly: 'true' })
                                ),
                                m('.col-8'),
                                m('.col-4',
                                    m('label.form-label', this.getText('LT00000778', 'Code')),
                                    m('input.form-control', { type: 'text', value: hierarchyDetail?.code, disabled: 'true', readonly: 'true' })
                                ),
                                m('.col-4',
                                    m('label.form-label', this.getText('LT00000011', 'Name')),
                                    m('input.form-control', { type: 'text', value: hierarchyDetail?.name, disabled: 'true', readonly: 'true' })
                                ),
                                m('.col-8',
                                    m('label.form-label', this.getText('LT00000012', 'Description')),
                                    m('input.form-control', { type: 'text', value: hierarchyDetail?.description, disabled: 'true', readonly: 'true' })
                                ),
                                m('.col-4'),
                                m('.col-4',
                                    m('label.form-label', this.getText('LT00000779', 'ETC Info')),
                                    m('input.form-control', { type: 'text', value: hierarchyDetail?.etcInfo, disabled: 'true', readonly: 'true' })
                                ),
                                m('.col-2',
                                    m('label.form-label', this.getText('LT00000780', 'Hierarchy Level')),
                                    m('input.form-control', { type: 'text', value: hierarchyDetail?.hierarchyLevel, disabled: 'true', readonly: 'true' })
                                ),
                                m('.col-2',
                                    m('.d-flex.flex-column.h-100',
                                        m('label.form-label', this.getText('LT00000015', 'Status')),
                                        m('.d-flex.flex-fill.align-items-center',
                                            m('div',
                                                hierarchyDetail?.status
                                                    ? m('.badge.rounded-pill.green-bg-status', this.getText('LT00000025', 'Active'))
                                                    : m('.badge.rounded-pill.grey-bg-status', this.getText('LT00000029', 'Inactive'))
                                            )
                                        )
                                    )
                                ),
                            )
                        ),
                        isDetailsLoading && m(Spinner, { active: true, fill: true, background: true })
                    )
                )
            ),
            this.getBaseViews()
        ]
    };
}